import{useContext as o}from"react";import{AlgoliaSearchContext as t}from"../contexts.js";function e(){return o(t)}export{e as useAlgoliaSearchContext};
//# sourceMappingURL=useAlgoliaSearchContext.js.map
